import React from "react"


class SearchBar extends React.Component {
	constructor(props) {
		super(props);
	}

	onHandleSearchChange = (e) => {
		this.props.onHandleSearchEvents(e.target.value, e.target.name)
	}

	render() {
		const { name } = this.props;

		return (
			<div className="flexbox"> 
				<div className="input-group-icon input-group-icon-left mr-3">
					<span className="input-icon input-icon-right font-16"><i className="ti-search"> </i></span>
					<input className="form-control form-control-rounded form-control-solid" type="text" placeholder="Tìm kiếm đại lý" name={name} value={this.props.search} onChange={this.onHandleSearchChange} />
				</div>
			</div>
		)
	}
}

export default SearchBar 


// WEBPACK FOOTER //
// ./src/components/dashboard/searchbar.js